<template>
    <transition name="zoom">
        <div class="fixed-return" @click="$router.go(-1)">返回</div>
    </transition>
</template>
<script>
export default {
    mounted () {
        var $btn = document.querySelector('.fixed-return')
        var distanceX = 25
        var distanceY = 25
        $btn.ontouchstart = (e) => {
            distanceY = e.touches[0].pageY - $btn.offsetTop
            distanceX = e.touches[0].pageX - $btn.offsetLeft
            $btn.style.webkitTransitionDuration = '0ms'
            e.preventDefault()
        }
        $btn.ontouchmove = (e) => {
            if (e.touches.length > 0) {
                $btn.style.top = e.touches[0].pageY - distanceY + 'px'
                $btn.style.left = e.touches[0].pageX - distanceX + 'px'
                // e.preventDefault()
            }
        }
        $btn.ontouchend = (e) => {
            $btn.style.webkitTransitionDuration = '300ms'
            if ($btn.offsetLeft < 15) {
                $btn.style.left = '15px'
            }
            if ($btn.offsetTop < 15) {
                $btn.style.top = '15px'
            }
            if ($btn.offsetLeft > document.body.clientWidth - 65) {
                $btn.style.left = document.body.clientWidth - 65 + 'px'
            }
            if ($btn.offsetTop > document.body.clientHeight - 65) {
                $btn.style.top = document.body.clientHeight - 130 + 'px'
            }
            e.preventDefault()
        }
    }
}
</script>

<style lang="less">
    .fixed-return {
        position: fixed;
        bottom: 80px;
        font-size: 12px;
        right: 15px;
        width: 50px;
        height: 22px;
        padding-top: 28px;
        color: #fff;
        z-index: 1000;
        box-shadow: 0 3px 16px rgba(33, 150, 243, 0.63);
        border-radius: 50%;
        text-align: center;
        animation-name: btzoomIn;
        animation-duration: 500ms;
        -webkit-touch-callout: none;
        user-select: none;
        background: url(../assets/images/returnbtn.png) no-repeat;
        background-size: 26px;
        background-position: center 3px;
        background-color: #00c4ff;
    }
    .zoom-leave-active {
        animation-name: btzoomOut;
        animation-duration: 500ms;
    }
    @keyframes btzoomOut {
        0% {
            opacity: 1;
            transform: scale(1) translateY(0);
        }
        100% {
            opacity: 0;
            transform: scale(.4) translateY(80%);
        }
    }
    @keyframes btzoomIn {
        0% {
            opacity: 0;
            transform: scale(.4) translateY(80%);
        }
        100% {
            opacity: 1;
            transform: scale(1) translateY(0);
        }
    }
</style>
